<template>
<el-form :model="formPlan" :rules="rules" ref="formPlan">
    <el-form-item class="custom-label" label="Fecha de visita" prop="fecha_visita" :rules="[
        {
          required: true,
          message: 'Este campo es obligatorio',
          trigger: 'change',
        },
      ]">
        <el-date-picker v-model="formPlan.fecha_visita"
            type="date"
            placeholder="Seleccione un día"
            format="dd/MM/yyyy"
            @change="getTickets"
            :disabled="false">
        </el-date-picker>
    </el-form-item>

    <div v-if="listPrecioEsta.length > 0 && formPlan.fecha_visita != null" class="row mt-4">

        <div class="col-sm-12 mb-4">
            <el-alert title="Agregar servicio de estacionamiento" type="success" effect="dark" :closable="false" />
        </div>

        <el-form-item label="Tipo de vehículo y tarifa">
            <el-select v-model="formPlan.tarifa" placeholder="please select your zone" @change="handleChangeEst">
                <el-option v-for="(item, index) in listPrecioEsta"
                    :key="`lst-cbo-${index}`"
                    :label="item.productoDescripcion"
                    :value="item.productoId" />
            </el-select>
        </el-form-item>

        <div class="form-group row">
          <div class="col-sm-5">
            <span>Número de vehículos</span>
          </div>
          <div class="col-sm-7">
            <el-input-number v-model="formPlan.carros" :min="0" :max="10" @change="handleChangeEst"></el-input-number>
          </div>
        </div>

        <div class="form-group row" v-if="formPlan.tarifa == 2">
          <div class="col-sm-5">
            <span>Horas alquilar</span>
          </div>
          <div class="col-sm-7">
            <el-input-number v-model="formPlan.horas" :min="1" :max="5" @change="handleChangeEstHoras"></el-input-number>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-5">
            <span>Importe a pagar</span>
          </div>
          <div class="col-sm-5">
            <h4 class="text-primary border rounded p-2">
                S/ {{ formPlan.importe.toFixed(2) }}
            </h4>
          </div>

          <hr>
          <h6 class="fw-bolder text-info">información adicional</h6>

          <div v-for="(item, index) in formPlan.placas" :key="index">
            <div class="d-flex align-items-center justify-content-between">
              <span>{{ 'Vehículo ' + (index+1) }}</span>
              <el-form-item :prop="'placas.' + index"
                :rules="[{ required: true, message: 'El número de placa es obligatorio', trigger: 'blur' }]" class="m-">
                <el-input v-model="formPlan.placas[index]" placeholder="Ingrese número de placa" size="mini" />
              </el-form-item>
            </div>

          </div>

        </div>



    </div>

    <div v-if="listPrecioEsta.length == 0 && formPlan.fecha_visita != null">
        <el-alert title="Lo sentimos, no se tiene el servicio de estacionamiento disponible para el parque seleccionado" type="error" effect="dark" :closable="false" />
    </div>

    <div class="mt-4"></div>


    <div class="d-flex justify-content-between">
        <button class="btn mb-3 mt-3 ml-2" @click.prevent="volver">
            Atras
        </button>
        <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('formPlan')">
            Siguiente
        </button>
    </div>

</el-form>
</template>

<script>
//services
import services from "@/services/services.service";
import moment from "moment";

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME,
} from "@/store/htmlclass.module.js";

import {
    mapGetters
} from "vuex";

export default {
    props: {
        club: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data: () => ({
        formPlan: {
            tarifa: '',
            tipovehiculo: '',
            fecha_visita: null,
            carros: 1,
            precio: 6,
            importe: 0,
            horas: 1,
            placas: []
        },
        rules: {
          placas: {
            type: 'array',
            required: true,
            defaultField: {
              type: 'string',
              required: true,
              message: 'El número de placa es obligatorio',
              trigger: 'blur'
            }
          }
        },

        listPrecioEsta: [],
        total_pagar: 0,
        listCarrito: [],

    }),

    watch: {
      'formPlan.carros'(newVal) {
        const placas = this.formPlan.placas;
        if (newVal > placas.length) {
          for (let i = placas.length; i < newVal; i++) {
            placas.push('');
          }
        } else if (newVal < placas.length) {
          placas.splice(newVal);
        }
      }
    },
    computed: {
        ...mapGetters(["totalPagar", "getDateVisit"]),
    },
    mounted() {
        //this.init();

        this.getTickets();
    },
    created() {
        //this.$store.dispatch("updateSubRouter", true);
    },
    methods: {
        volver() {
            this.$emit("resVolver", 1);
        },

        async getTickets() {
            let hoy = moment().format("YYYY-MM-DD");
            let current = moment(this.formPlan.fecha_visita).format("YYYY-MM-DD");

            if (current < hoy) {
                this.formPlan.fecha_visita = null;
                this.listTickets = [];
                this.listTicketsFree = [];
                alert("No puede seleccionar una fecha anterior.");
            } else {

              const f = new Date();
              this.formPlan.fecha_visita = f.toLocaleDateString();

                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

                this.formPlan.carros = 0;
                this.formPlan.precio = 0;
                this.formPlan.importe = 0;
                this.total_pagar = 0;
                const axiosInstance = axios.create({
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                    },
                });

                axiosInstance
                    .post(`${process.env.API4}/v1/cc/result4`, {
                        ue: "001066",
                        sede: this.club.idseat,
                        areaId: this.club.idseat,
                        categoriaId: "004",
                    })
                    .then((response) => {
                        this.listPrecioEsta = response.data;

                        if(response.data.length == 1){
                            this.formPlan.tarifa = this.listPrecioEsta[0]['productoId'];
                        }
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    })
                    .catch((err) => {
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                        this.showError(err);
                    });
            }
        },

        handleChangeEst(value) {

            const item = this.listPrecioEsta.find(
            item => item.productoId === this.formPlan.tarifa
            );

            const pUnitario = item ? item.pUnitario : 0;

            this.formPlan.precio = pUnitario;
            this.formPlan.importe = this.formPlan.carros * this.formPlan.horas * this.formPlan.precio;
            //agregar fila placa
            this.formPlan.placas.push('');
        },

        handleChangeEstHoras(value) {
            const item = this.listPrecioEsta.find(
            item => item.productoId === this.formPlan.tarifa
            );

            const pUnitario = item ? item.pUnitario : 0;

            this.formPlan.precio = pUnitario;
            this.formPlan.importe = this.formPlan.carros * this.formPlan.horas * this.formPlan.precio;
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return false;

                if (this.listCarrito.length == 0)
                    if (this.listCarrito.length > 0)
                        return alert(
                            "Su carrito se encuentra vacío, por favor agrege productos a su cesta."
                        );

                if (this.formPlan.carros > 0) {

                    let tmpcar = {
                        item: this.listCarrito.length + 1,
                        areaId: this.club.idseat,
                        producto: this.listPrecioEsta[0].productoId,
                        descripcionProducto:  'ESTACIONAMIENTO DE ' + this.listPrecioEsta[0].productoDescripcion + ' - ' + this.formPlan.carros + ' vehículos',
                        precioUnitario: this.formPlan.precio,
                        cantidad: this.formPlan.horas,
                        total: this.formPlan.importe,
                        ordercategory: 16,
                    };
                    this.listCarrito.push(tmpcar);
                    this.$store.dispatch("updateDateVisit", moment(this.formPlan.date_visit).format('DD/MM/YYYY'));
                    this.$store.dispatch("updateCarrito", this.listCarrito);
                    this.$emit("resCarrito", this.listCarrito)
                }

            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/parking/Tickets.vue